export default {
  title: 'headline.content_template'
};
